"use client";

import Link from 'next/link';
import { motion } from 'framer-motion';
import Image from 'next/image'; // Import Image from next/image
import { pagenotfound } from '@/images';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Use the Next.js Image component */}
          <Image 
            src={pagenotfound} // The path to your image inside public folder
            alt="Not Found" 
            width={400} // Specify the width
            height={300} // Specify the height
            className="mx-auto mb-8" 
          />
        </motion.div>

        {/* Subheading */}
        <motion.p 
          className="text-xl text-gray-800 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Page not found
        </motion.p>

        {/* Button Section */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Link 
            href="/"
            className="px-8 py-4 rounded-lg  text-black border-black/40 font-semibold text-lg shadow-lg transform transition-all hover:scale-105 hover:opacity-90 active:scale-95"
          >
            Go Home
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
